// @flow
import React from 'react'
import MediaQuery from 'react-responsive'
import Slider from '../sliders/slider'
import TopBar from '../bars/top-bar'
//import CtaButton from '../buttons/cta-button'
import InfoText from '../texts/info-text'
import NormalText from '../texts/normal-text'
import CardGallery from '../cards/card-gallery'
import Card from '../cards/card'
import ScrollHandler from '../../services/search-results/scroll-handler'
import { GridRow, GridCol } from '../grid'
import { domains } from '../../services'

type SearchResultsAuctionsProps = {
  auctionsList: number[],
  id: number,
  handleScroll: () => void,
  handleSliderChange: () => void,
  translations: { [key: string]: string },
  auctionCountdownText: string
}

const SearchResultsAuctions = (props: SearchResultsAuctionsProps) => {
  const {
    auctionsList,
    id,
    handleScroll,
    handleSliderChange,
    translations,
    auctionCountdownText
  } = props
  return (
    <div>
      <TopBar
        leftChildren={
          <NormalText key={1}>{`${auctionsList.length} ${
            translations.results
          }`}</NormalText>
        }
        // rightChildren={<IconButton iconName='filters' text='filters' key={1} />}
      />
      <MediaQuery query='(min-width: 1024px)'>
        <ScrollHandler onScroll={handleScroll}>
          <CardGallery cards={auctionsList}>
            <Card domain={domains.AUCTIONS} />
          </CardGallery>
        </ScrollHandler>
      </MediaQuery>

      <MediaQuery query='(max-width: 1023px)'>
        <Slider
          active={id}
          slides={auctionsList}
          afterChange={handleSliderChange}
        >
          <Card domain={domains.AUCTIONS} />
        </Slider>
        <div className='inner-wrapper'>
          <GridRow>
            <GridCol type='one-whole'>
              <InfoText hasIcon={false} className='center'>
                <p>{auctionCountdownText}</p>
              </InfoText>
            </GridCol>
          </GridRow>
        </div>
        <div className='action-thin-block' />
      </MediaQuery>
    </div>
  )
}

SearchResultsAuctions.defaultProps = {
  translations: {
    results: 'results'
  }
}

export default SearchResultsAuctions



// WEBPACK FOOTER //
// ./src/ui/views/search-results-auctions.js